import { render, staticRenderFns } from "./buyerInformation.vue?vue&type=template&id=08925cab&scoped=true"
import script from "./buyerInformation.vue?vue&type=script&lang=js"
export * from "./buyerInformation.vue?vue&type=script&lang=js"
import style0 from "./buyerInformation.vue?vue&type=style&index=0&id=08925cab&prod&lang=less"
import style1 from "./buyerInformation.vue?vue&type=style&index=1&id=08925cab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08925cab",
  null
  
)

export default component.exports